export const SET_HOME_ACCENT_PANEL_BG = '#5C5854' as const;
export const SET_HOME_TOAST_MAX_WIDTH_PX = 405 as const;
export const SET_HOME_TOAST_ICON_PX = 20 as const;
